export enum UploadStatus {
  initial,
  signing,
  uploading,
  success,
  error,
}
